import { render } from "./ShowAccessGroupMember.vue?vue&type=template&id=05768106"
import script from "./ShowAccessGroupMember.vue?vue&type=script&lang=js"
export * from "./ShowAccessGroupMember.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__